import Post from "../Post";
import getToken from "../token";

export default function getMessages(number = 99999, sender = "user") {
  return Post("ticket/ticketMessages", {
    token: getToken(),
    limit: number,
    kindType: sender,
    page: 1,
  });
}
